/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSigintSignalSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetSigintSignalSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetSigintSignalSecurity = {
  option1?: GetSigintSignalSecurityOption1 | undefined;
  option2?: GetSigintSignalSecurityOption2 | undefined;
};

export type GetSigintSignalRequest = {
  /**
   * Custom signal ID
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetSigintSignalSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetSigintSignalSecurityOption1$outboundSchema: z.ZodMiniType<
  GetSigintSignalSecurityOption1$Outbound,
  GetSigintSignalSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSigintSignalSecurityOption1ToJSON(
  getSigintSignalSecurityOption1: GetSigintSignalSecurityOption1,
): string {
  return JSON.stringify(
    GetSigintSignalSecurityOption1$outboundSchema.parse(
      getSigintSignalSecurityOption1,
    ),
  );
}

/** @internal */
export type GetSigintSignalSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetSigintSignalSecurityOption2$outboundSchema: z.ZodMiniType<
  GetSigintSignalSecurityOption2$Outbound,
  GetSigintSignalSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getSigintSignalSecurityOption2ToJSON(
  getSigintSignalSecurityOption2: GetSigintSignalSecurityOption2,
): string {
  return JSON.stringify(
    GetSigintSignalSecurityOption2$outboundSchema.parse(
      getSigintSignalSecurityOption2,
    ),
  );
}

/** @internal */
export type GetSigintSignalSecurity$Outbound = {
  Option1?: GetSigintSignalSecurityOption1$Outbound | undefined;
  Option2?: GetSigintSignalSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetSigintSignalSecurity$outboundSchema: z.ZodMiniType<
  GetSigintSignalSecurity$Outbound,
  GetSigintSignalSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetSigintSignalSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetSigintSignalSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getSigintSignalSecurityToJSON(
  getSigintSignalSecurity: GetSigintSignalSecurity,
): string {
  return JSON.stringify(
    GetSigintSignalSecurity$outboundSchema.parse(getSigintSignalSecurity),
  );
}

/** @internal */
export type GetSigintSignalRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetSigintSignalRequest$outboundSchema: z.ZodMiniType<
  GetSigintSignalRequest$Outbound,
  GetSigintSignalRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getSigintSignalRequestToJSON(
  getSigintSignalRequest: GetSigintSignalRequest,
): string {
  return JSON.stringify(
    GetSigintSignalRequest$outboundSchema.parse(getSigintSignalRequest),
  );
}
